import contact from './contact';
import landing from './templateLandingPage';

export default {
  init() {
    contact.handleContactForm();
    landing.parallaxImage();
    landing.slider();
    landing.playVideoOnScroll();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleSolution.js